import { mapState, mapMutations } from "vuex";
import NewMultiplePeopleNewCase from "../components/NewCase.vue";
import listItem from "../components/listItem.vue";
import * as apis from "@/api";
import InteractivePanel from "@/components/interactive_panel";
import countDown from "@/components/countDown";
import { conversion, addZero, formatDate } from "@/tool";
import { awards_sort } from "@/utils/awards";
export default {
  components: {
    "c-new-multiple-people-case": NewMultiplePeopleNewCase,
    "c-interactive-panel": InteractivePanel,
    "c-list-item": listItem,
    "c-countDown": countDown,
  },
  computed: {
    ...mapState(["user" , "boxList" , "mpCaseList"]),
    curUserRealId() {
      return parseInt(this.user.id );
    },
    backIconWidthHeight() {
      return this.$screen.mobile ? "16px" : "21px";
    },
  },
  data() {
    return {
      tabs: "all",
      new_multiplePeople_cases_show: false,
      recentCaseParams: {
        pageIndex: 1,
        pageSize: 20,
        total: 0,
      },
      historyCaseParams: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      myCaseParams: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      multiplePeopleCaseList: [],
      multiplePeopleCaseListRecent: [],
      caseData: [],
      battleCaseList: [],
      initData1: true,
      mpcCaseSettings: {},
      multiplePeople_cases_rules_show: false,
      isShowShaixuan: false,
    };
  },
  filters: {
    conversion,
    addZero,
    formatDate,
  },
  watch: {
    multiplePeopleCaseList(val) {
      val.forEach((item) => {
        item.joinPrice = 0;
        item.joinRatio = 0;
        item.endTime = new Date(item.endTime).getTime();
        if (item.cases && item.cases.length == 1) {
          item["currentCaseName"] = item.cases[0].name;
        } else if (item.cases && item.cases.length > 1) {
          item.cases.sort((a, b) => b.price - a.price);
          item["currentCaseName"] = `${item.cases[0].name}...`;
        }
        if (item.players && item.players.length > 0) {
          item.players.forEach((player) => {
            player["ratio"] = `${Math.floor(
              Number((player.amount / item.price) * 100)
            )}`;
            if (this.curUserRealId == player.id) {
              item.joinPrice = player.amount;
              item.joinRatio = player.ratio;
            }
          });
        }
      });
    },
  },
  async created() {
    this.tabs = this.$route.params.tabType;

    await this.switchTabs(this.tabs);
    await this.setSpinShow(false);

        //监听MPCaseFinished 开箱成功通知
    //await this.onListenMPCaseFinished();
  },
  async mounted() {
  },
  async beforeDestroy() {
    this.$mpCaseHub.onConnected = null;
    this.$mpCaseHub.onReconnected = null;
    this.$mpCaseHub.conn.off("MPCaseFinished");
  },
  methods: {
    ...mapMutations(["setSpinShow" , "getboxList"]),
    //监听MPCaseFinished 开箱成功通知
    onListenMPCaseFinished() {
      const _this = this;
      _this.$mpCaseHub.conn.on("MPCaseFinished", async (data) => {
        console.log("监听收到开箱成功通知", data);
        let players = data.players.filter(
          (item) => item.id == _this.curUserRealId
        );
        console.log("players==", players);
        if (players.length > 0) {
          await _this.$toast.success(`合开箱【${data.cases[0].name}】打开中~`);
        }
        await this.multiplePeopleCaseList.forEach(async (els) => {
          console.log("els===", els, els.id == data.id);
          if (els.id == data.id) {
            els.status = 4;
            setTimeout(async () => {
              els.status = 1;
              if (players.length > 0) {
                await _this.$toast.success(`合开箱【${data.cases[0].name}】已打开~`);
              }
              return;
            }, 15000);
          }
        });
      });
    },
    //获取多人集资开箱列表
    async getMultiplePeopleCaseRecentList() {
      let _this = this,
        params = {
          pageIndex: 1,
          pageSize: 100,
        };
      const multiplePeopleCaseRecentList_response =
        await apis.multiplePeopleCaseRecentList(params);
      if (multiplePeopleCaseRecentList_response.data.code !== 0) {
        return;
      }
      //如果从case过来的
      if (this.$route.params.caseId && this.initData1) {
        _this.multiplePeopleCaseListRecent = [];
        multiplePeopleCaseRecentList_response.data.data.items.forEach((res) => {
          let newCases = res.cases.filter(
            (_) => _.id == this.$route.params.caseId
          );
          if (newCases.length >= 1) {
            _this.multiplePeopleCaseListRecent.push(res);
          }
        });
        setTimeout(() => {
          this.initData1 = false;
          if (_this.multiplePeopleCaseListRecent.length == 0 && this.user.nickname) {
            this.caseData.forEach((els) => {
              if (els.caseId == this.$route.params.caseId) {
                els.count = 1;
              }
            });
            this.new_multiplePeople_cases_show = true;
          }
        }, 1000);
      } else {
        this.recentCaseParams.total =
        multiplePeopleCaseRecentList_response.data.data.totalCount;
        _this.multiplePeopleCaseListRecent =
          multiplePeopleCaseRecentList_response.data.data.items.sort((a, b) => a.status - b.status);
      }
      this.getMultiplePeopleCaseRecentListTemp();
    },
    getMultiplePeopleCaseRecentListTemp() {
      const start = (this.recentCaseParams.pageIndex - 1) * this.recentCaseParams.pageSize;
      const end = start + this.recentCaseParams.pageSize
      this.multiplePeopleCaseList = this.multiplePeopleCaseListRecent.slice(start, end);
    },
    async switchTabs(tab) {
      this.tabs = tab;
      this.multiplePeopleCaseList = [];
      if (this.tabs == "all") {
        await this.getMultiplePeopleCaseRecentList();
      } else if (this.tabs == "mine") {
        await this.getMultiplePeopleCaseMineList();
      } else if (this.tabs == "history") {
        await this.getMultiplePeopleCaseHistoryList();
      }
      await this.$forceUpdate();
    },
    async getMultiplePeopleCaseMineList() {
      let _this = this,
      params = {
        pageIndex: this.myCaseParams.pageIndex,
        pageSize: this.myCaseParams.pageSize,
      };
      const multiplePeopleCaseMineList_response =
        await apis.multiplePeopleCaseMineList(params);
      if (multiplePeopleCaseMineList_response.data.code !== 0) {
        return;
      }
      this.myCaseParams.total =
        multiplePeopleCaseMineList_response.data.data.totalCount;
      _this.multiplePeopleCaseList =
        multiplePeopleCaseMineList_response.data.data.items;
    },
    async getMultiplePeopleCaseHistoryList() {
      let _this = this,
        params = {
          pageIndex: this.historyCaseParams.pageIndex,
          pageSize: this.historyCaseParams.pageSize,
        };
      const multiplePeopleCaseHistoryList_response =
        await apis.multiplePeopleCaseHistoryList(params);
      if (multiplePeopleCaseHistoryList_response.data.code !== 0) {
        return;
      }
      this.historyCaseParams.total =
        multiplePeopleCaseHistoryList_response.data.data.totalCount;
      _this.multiplePeopleCaseList =
        multiplePeopleCaseHistoryList_response.data.data.items;
    },
    openCreateNewCase() {
      if (!this.user.nickname) return this.$store.commit("setloginModal", true);
      this.new_multiplePeople_cases_show = true;
      this.isShowShaixuan = true;
    },
    createNewMultiplepeopleCase(data) {
      this.$mpCaseHub.conn
        .invoke("GCRequestCreateMPCase", data)
        .then(async (lpMsg) => {
          if (lpMsg.success) {
            await this.$toast.success(lpMsg.data);
            await this.$refs.newMultiplepeopleCase.reset();
            this.new_multiplePeople_cases_show = false;
            this.isShowShaixuan = false;
            await this.$store.commit("setInfo");
            await this.switchTabs(this.tabs); //按照当前tab重新获取列表
            await this.$forceUpdate();
          } else {
            this.$toast.error(lpMsg.msg);
            this.$refs.newMultiplepeopleCase.reset();
          }
        });
    },
    handleShowmultiplePeopleCaseDetail(item) {
      this.$router.push({
        name: "multiplePeopleCaseDetail",
        params: {
          id: item.id,
          isAutoOpenAward: item.status == "4" ? true : false,
        },
        query: this.$route.query || {},
      });
    },
  },
};
